import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { AccountInvite } from './components/accountInvite';
import { Accounts } from './components/accounts';
import { AccountsFilterPage } from './components/accountsFilterPage';

export const accountRoute = [
  {
    path: 'accounts/filters',
    element: <AccountsFilterPage />,
    handle: {
      header: {
        titleKey: 'people.menu.people',
        icon: 'account-multiple',
      },
      requiredPermission: Permissions.peoplepage.read,
    },
  },
  {
    path: 'accounts/:workspaceId?',
    element: <Accounts />,
    handle: {
      header: {
        titleKey: 'people.menu.people',
        icon: 'account-multiple',
      },
      requiredPermission: Permissions.peoplepage.read,
    },
  },
  {
    path: 'account/invite',
    element: <AccountInvite />,
    handle: {
      header: {
        titleKey: 'people.menu.people',
        icon: 'account-multiple',
      },
      requiredPermission: Permissions.peoplepage.read,
    },
  },
];
